export default __webpack_public_path__ + "static/media/(81).02c0eac9.jpg";